import { AxiosRequestConfig } from 'axios';
import { unsConstants } from 'constants/index';
import {
  AxiosRequestCustomConfig,
  IGetMessagesData,
  IGetMessagesParams,
  IMarkReadAllParams,
  IRegisterTokenParams,
} from 'interfaces';
import { requestServices } from 'services';

const { unsClient } = requestServices;
const { FCM_TOKEN } = unsConstants;

const getDeviceToken = () => localStorage.getItem(FCM_TOKEN) || undefined;

const registerToken = async (params: IRegisterTokenParams): Promise<void> => {
  return unsClient.post('/notification/register-token', params);
};

const getMessages = async (
  params: IGetMessagesParams,
  options?: { bypassError?: boolean }
): Promise<IGetMessagesData> => {
  const requestConfig: AxiosRequestConfig & AxiosRequestCustomConfig = {
    params: { token: getDeviceToken(), externalTypes: ['noti'], ...params },
    isBypassNormalErrorRequests: options?.bypassError,
  };

  const { data } = await unsClient.get('/notifications', requestConfig);
  return data?.data || {};
};

const markRead = async (msgId: number): Promise<void> => {
  return unsClient.put(`/notification/${msgId}/mark-read`, {
    token: getDeviceToken(),
  });
};

const markReadAll = async (params: IMarkReadAllParams): Promise<void> => {
  return unsClient.put('/notification/mark-read-all', {
    token: getDeviceToken(),
    externalTypes: ['noti'],
    ...params,
  });
};

export default {
  registerToken,
  getMessages,
  markRead,
  markReadAll,
};
